import React from "react";
import "./TableButtons.css";

/**
 * EditRowButton - Pencil icon button for enabling inline table edit
 *
 * @param {boolean} props.loading - When true, shows a spinner and disables the button
 * @example
 * <EditRowButton onClick={handleEdit} disabled={isEditing} loading={isLoading} />
 */
const EditRowButton = ({ onClick, disabled = false, loading = false, ariaLabel = "Edit row", ...props }) => {
  return (
    <button
      className="edit-row"
      onClick={onClick}
      disabled={disabled || loading}
      aria-label={ariaLabel}
      title="Edit"
      {...props}
    >
      {loading ? (
        <span className="table-btn-spinner" />
      ) : (
        <svg
          width="18"
          height="18"
          viewBox="0 0 15 15"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M13.4192 5.57534L9.93101 2.12329L11.0801 0.972603C11.3947 0.657534 11.7811 0.5 12.2394 0.5C12.6976 0.5 13.084 0.657534 13.3987 0.972603L14.5477 2.12329C14.8623 2.43836 15.0265 2.81849 15.0402 3.2637C15.0538 3.7089 14.9034 4.08904 14.5888 4.40411L13.4192 5.57534ZM12.2291 6.78767L3.52919 15.5H0V12.0068L8.74093 3.29452L12.2291 6.78767Z"
            fill="white"
          />
        </svg>
      )}
    </button>
  );
};

export default EditRowButton;

